<template>
    <div class="film-card">
      <h1>{{ film.title }}</h1>
      <div class="mb-4">
      <p v-if="film.year"><strong>{{ film.year }} - {{ film.duration }}</strong></p>
      <p v-if="film.production">Production <strong>{{ film.production }}</strong> {{ film.coproduction }} <strong>Les Alchimistes</strong></p>
      <p v-if="film.coproduction"> </p>
      </div>
      <div class="mb-4 synopsis">
          <p>{{ film.synopsis }}</p>
      </div>
  
      <div class="mb-4">
            <p v-for="(member, role) in film.crew" :key="role">
              {{ role }} : {{ member }}
            </p>
      </div>
  
      <div class="mb-4">
        <h4 v-if="film.festivals_title">{{ film.festivals_title }}</h4>
            <p v-for="(festival, index) in film.festivals" :key="index">
              {{ festival.name }}
            </p>
            <h4 v-if="film.residences_title">{{ film.residences_title }}</h4>
            <p v-for="(residence, index) in film.residences" :key="index">
              {{ residence.name }}
            </p>
      </div>
  
      <div v-if="film.availability">
        <a :href="film.availability.link" target="_blank" rel="noopener">{{ film.availability.text }}</a>
      </div>
    </div>
  </template>
  
  <script>
  export default {
    props: {
      film: Object,
    },
  };
  </script>
  
  <style scoped>
  .film-card {
    padding: 1.5rem;
    margin-bottom: 1.5rem;
  }
  .film-card h1 {
    margin-bottom: 1rem;
    font-size: 2.2em;
    color: #2c4a3e;
  }

  .film-card li{
    font-size: 1.2em;
  }

  .film-card  p{
    font-size: 1.2em;
    font-weight: 500;
  }
  .film-card a {
    color: #2c4a3e;
    text-decoration: underline;
    font-size: 1.2em;
  }
  .film-card a:hover {
    text-decoration: underline;
  }
  </style>